import {
    Button,
    Col,
    CreateButton,
    Dropdown,
    Form,
    Icons,
    Input,
    List,
    Menu,
    Row,
    Space,
    Table,
    Tooltip,
    message,
    useModalForm,
    Icon,
    Popconfirm,
  } from '@pankod/refine-antd'
  import React, { useEffect, useState } from 'react'
  import { getOpenApiPermissionUsers, getUsersListAdmin } from 'users'
  import { getAiDetails } from 'gql/query'
  import { updateAiConfigDetails } from 'gql/mutations'
  import { log } from 'console'
  import { updateUserStatus } from 'helpers/ai_config/updateUserStatus'
  import { title } from 'process'
  
  const AiConfigList = () => {
    const [totalUsers, setTotalUsers] = useState<number>(0)
    const [limit, setLimit] = useState<number>(10)
    const [offset, setOffset] = useState<number>(0)
    const [users, setUsers] = useState<any>([])
    const [allUsers, setAllUsers] = useState<any>([])
    const [searchValue, setSearchValue] = useState<string>('')
    const [loading, setLoading] = useState<boolean>(false)
    const [currentPage, setCurrentPage] = useState<number>(1)
    const [form] = Form.useForm()
    const [currentLimit, setCurrentLimit] = useState<number>(0)
    const [currentModel, setCurrentModal] = useState<string>('')
    const [listModel, setListModel] = useState([])
    const [listLimit, setListLimit] = useState([])
    const [configLoading, setConfigLoading] = useState<boolean>(false)
  
    //fetching all details
    const fetchAllDetails = async () => {
      try {
        getOpenApiPermissionUsers(limit, offset, searchValue).then(async (response: any) => {
          setUsers(response?.users)
          setTotalUsers(response?.usersAggregate?.aggregate?.count)
  
          const allUsersList: any = await getUsersListAdmin(1000, 0, '')
          if (allUsersList.users.length > 0) {
            setAllUsers(allUsersList.users)
          }
  
          //finding list of model and limit
          if (listModel.length <= 0 || listLimit.length <= 0) {
            //finding model details
            getAiDetails(true, false).then((modelResponse: any) => {
              if (modelResponse.ai_models.length >= 1) {
                setListModel(modelResponse.ai_models)
                const modelIndex = modelResponse.ai_models.findIndex((model: any) => model.in_use === true)
                if (modelIndex !== -1) {
                  //setting current model
                  setCurrentModal(modelResponse.ai_models[modelIndex].model_name)
                }
              }
              //find limit details
              getAiDetails(false, true).then((limitResponse: any) => {
                if (limitResponse.ai_limit.length >= 1) {
                  setListLimit(limitResponse.ai_limit)
                  const limitIndex = limitResponse.ai_limit.findIndex((limit: any) => limit.in_use === true)
                  if (limitIndex !== -1) {
                    //setting current limit
                    setCurrentLimit(limitResponse.ai_limit[limitIndex].limit)
                  }
                }
              })
            })
          }
        })
      } catch (err) {
        console.log(err, 'error')
      }
    }
  
    useEffect(() => {
      setLoading(true)
      //for fetching all details
      fetchAllDetails()
      setLoading(false)
    }, [limit, offset, searchValue])
  
    //on page changes
    const onChange = (page: number, pageSize: number) => {
      let offsetValue = (page - 1) * limit
      setCurrentPage(page)
      setOffset(offsetValue)
      setLimit(pageSize)
    }
  
    //user coloumns
    const columns = [
      {
        dataIndex: 'displayName',
        title: 'User Name',
      },
      {
        dataIndex: 'email',
        title: 'email Id',
      },
      {
        dataIndex: 'defaultRole',
        title: 'Primary Role',
      },
      {
        title: 'Actions',
        render: (text: any, record: any) => (
          <Popconfirm
            title={`Are you sure do you want to remove ${record.displayName}'s permission ?`}
            okText="Yes"
            cancelText="No"
            onConfirm={async () => {
              if (record.id) {
                const statusChange: any = await updateUserStatus(record.id, 'remove')
                if (statusChange?.status) {
                  await fetchAllDetails()
                  message.success('Successfully removed the user permission...')
                } else {
                  message.error('Failed to remove user permission...')
                }
              }
            }}
          >
            <Button icon={<Icons.DeleteOutlined />} />
          </Popconfirm>
        ),
      },
    ]
  
    //updating the model or limit
    const handleConfigChange = async (value: string, type: string) => {
      setConfigLoading(true)
      if (type === 'model') {
        const updateModel: any = await updateAiConfigDetails(value, 'model')
        if (!updateModel.errors) {
          setCurrentModal(value)
          message.success(`Successfully updated the model to ${value}`)
        } else {
          message.error(`failed updated the model to ${value}`)
        }
      } else {
        const updateLimit: any = await updateAiConfigDetails(value, 'limit')
        if (!updateLimit.errors) {
          setCurrentLimit(parseInt(value))
          message.success(`Successfully updated the limit to ${value}`)
        } else {
          message.error(`failed updated the limit to ${value}`)
        }
      }
      setConfigLoading(false)
    }
    //model menu list
    const modelMenu = (
      <Menu onClick={e => handleConfigChange(e.key, 'model')}>
        {listModel.map((model: any) => (
          <Menu.Item disabled={model.model_name === currentModel} key={model.model_name}>
            {model.model_name}
          </Menu.Item>
        ))}
      </Menu>
    )
    //limit menu list
    const limitMenu = (
      <Menu onClick={e => handleConfigChange(e.key, 'limit')}>
        {listLimit.map((limitDetails: any) => (
          <Menu.Item disabled={limitDetails.limit === currentLimit} key={limitDetails.limit}>
            {limitDetails.limit} - limit
          </Menu.Item>
        ))}
      </Menu>
    )
  
    const usersMenu = (
      <Menu
        onClick={async e => {
          setConfigLoading(true)
          const statusChange: any = await updateUserStatus(e.key, 'add')
          if (statusChange?.status) {
            await fetchAllDetails()
            message.success('Successfully added new user...')
          } else {
            message.error('Failed to add new user...')
          }
          setConfigLoading(false)
        }}
        style={{ maxHeight: '200px', overflowY: 'auto', scrollbarWidth: 'thin' }}
      >
        {allUsers.map((user: any) => {
          if (user.ai_permission === true || user.displayName === 'Admin' || user.disabled === true) {
            return false
          } else {
            return <Menu.Item key={user.id}>{user.displayName}</Menu.Item>
          }
        })}
      </Menu>
    )
  
    return (
      <>
        <List title="AI-USERS">
          <Row justify="space-between" align="middle">
            {/* search bar... */}
            <Col style={{ marginBottom: '1rem' }}>
              <Form form={form}>
                <Space>
                  <Form.Item name="name">
                    <Input
                      value={searchValue}
                      placeholder="Search by Name..."
                      onChange={e => {
                        setSearchValue(e.target.value)
                      }}
                      suffix={
                        <>
                          <Icons.SearchOutlined style={{ cursor: 'pointer' }} />
                          <Icons.CloseCircleOutlined
                            style={{ cursor: 'pointer', marginLeft: '8px' }}
                            onClick={() => {
                              setSearchValue('')
                              form.resetFields(['name'])
                            }}
                          />
                        </>
                      }
                    />
                  </Form.Item>
                </Space>
              </Form>
            </Col>
            {/* extra buttons... */}
            <Col style={{ marginBottom: '1rem' }}>
              <Space>
                <Dropdown.Button
                  placement="bottom"
                  overlay={usersMenu}
                  icon={<Icons.UserAddOutlined />}
                  buttonsRender={([leftButton, rightButton]) => [
                    <Tooltip title="Click right side for add user" key="leftButton">
                      {leftButton}
                    </Tooltip>,
                    React.cloneElement(rightButton as React.ReactElement<any, string>, { loading: configLoading }),
                  ]}
                >
                  Add User
                </Dropdown.Button>
  
                <Dropdown.Button
                  placement="bottom"
                  overlay={modelMenu}
                  icon={<Icons.PlusCircleFilled />}
                  buttonsRender={([leftButton, rightButton]) => [
                    <Tooltip title="Click right side for update" key="leftButton">
                      {leftButton}
                    </Tooltip>,
                    React.cloneElement(rightButton as React.ReactElement<any, string>, { loading: configLoading }),
                  ]}
                >
                  {currentModel === '' ? 'gpt-4o /model' : `${currentModel} /model`}
                </Dropdown.Button>
                <Dropdown.Button
                  placement="bottom"
                  overlay={limitMenu}
                  icon={<Icons.PlusCircleFilled />}
                  buttonsRender={([leftButton, rightButton]) => [
                    <Tooltip title="Click right side for update" key="leftButton">
                      {leftButton}
                    </Tooltip>,
                    React.cloneElement(rightButton as React.ReactElement<any, string>, { loading: configLoading }),
                  ]}
                >
                  {currentLimit === 0 ? '5 /limit' : `${currentLimit} /limit`}
                </Dropdown.Button>
              </Space>
            </Col>
          </Row>
          {/* if its not loading... */}
          {!loading && (
            <Table
              size="small"
              scroll={{ x: 700 }}
              columns={columns}
              dataSource={users}
              pagination={{
                total: totalUsers,
                current: currentPage,
                onChange,
              }}
            />
          )}
          {/* if loading then showing loading...*/}
          {loading && <p>loading...</p>}
        </List>
      </>
    )
  }
  
  export default AiConfigList